import { defaultMetricsControls } from "@/lib/companyMetrics/state";
import { getChart } from "@/lib/companyMetrics/chartRegistry";
import { resolveChartSlug } from "@/lib/researchSearch/researchSearchIndex";

const VALID_PERIODS = new Set(["quarter", "annual"]);
const VALID_RANGES = new Set(["1Y", "3Y", "5Y", "10Y", "Max"]);
const VALID_GROWTH = new Set(["yoy", "cagr3", "cagr5"]);

export function parseResearchControls(searchParams) {
  const base = defaultMetricsControls();
  const period = searchParams.get("period");
  const range = searchParams.get("range");
  const growth = searchParams.get("growth") || searchParams.get("growthMode");

  return {
    ...base,
    period: VALID_PERIODS.has(period) ? period : base.period,
    range: VALID_RANGES.has(range) ? range : base.range,
    showEstimates: searchParams.get("estimates") !== "false",
    showYoY: searchParams.get("yoy") === "true",
    showMedian: searchParams.get("median") === "true" || (searchParams.get("median") !== "false" && base.showMedian),
    growthMode: VALID_GROWTH.has(growth) ? growth : base.growthMode,
  };
}

export function buildResearchSearchParams(controls = {}) {
  const params = new URLSearchParams();
  if (controls.period && controls.period !== "quarter") params.set("period", controls.period);
  if (controls.range && controls.range !== "5Y") params.set("range", controls.range);
  if (controls.showEstimates === false) params.set("estimates", "false");
  if (controls.showYoY) params.set("yoy", "true");
  if (controls.showMedian) params.set("median", "true");
  if (controls.growthMode && controls.growthMode !== "yoy") params.set("growth", controls.growthMode);
  return params;
}

export function buildMetricViewUrl(ticker, metricId, controls = {}) {
  const params = buildResearchSearchParams(controls);
  const qs = params.toString();
  const base = `/research/${String(ticker || "").toUpperCase()}/metrics/${metricId}`;
  return qs ? `${base}?${qs}` : base;
}

export function buildBusinessProfileUrl(ticker, tabId, controls = {}) {
  const params = buildResearchSearchParams(controls);
  if (tabId) params.set("tab", tabId);
  const qs = params.toString();
  const base = `/research/${String(ticker || "").toUpperCase()}`;
  return qs ? `${base}?${qs}` : base;
}

/** Legacy /charts URL → Research Desk route (preserves query string at redirect site). */
export function legacyChartUrlToResearch(pathname) {
  const deepMatch = pathname.match(/^\/charts\/([^/]+)\/([^/?]+)/i);
  if (deepMatch) {
    const [, ticker, slug] = deepMatch;
    const chartId = resolveChartSlug(slug);
    const chart = chartId ? getChart(chartId) : null;
    const metricId = chart?.metricIds?.[0] || slug.replace(/-/g, "_");
    return buildMetricViewUrl(ticker, metricId);
  }

  const tickerMatch = pathname.match(/^\/charts\/([^/?]+)/i);
  if (tickerMatch) {
    return `/research/${String(tickerMatch[1]).toUpperCase()}`;
  }

  return "/research";
}

// Backward compat
export const parseExplorerControls = parseResearchControls;
export const buildExplorerSearchParams = buildResearchSearchParams;
